var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashDelay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#FFF7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 19.945L14.94 20.94C14.63 20.98 14.31 21 14 21C10.14 21 7 17.86 7 14C7 10.14 10.14 7 14 7C14.315 7 14.63 7.02 14.94 7.06L14.805 8.055C14.54 8.02 14.27 8 14 8C10.69 8 8 10.69 8 14C8 17.31 10.69 20 14 20C14.27 20 14.54 19.98 14.81 19.945ZM18.275 19.543L17.664 18.751C17.249 19.072 16.795 19.336 16.314 19.537L16.701 20.46C17.261 20.225 17.7905 19.9165 18.275 19.543ZM20.47 16.6745L19.5465 16.2925C19.3465 16.7752 19.0843 17.2297 18.7665 17.6445L19.5605 18.253C19.9313 17.7687 20.2367 17.2381 20.47 16.6745ZM21 14C21 13.6975 20.98 13.3925 20.942 13.093L19.9495 13.2215C19.9835 13.4785 20 13.74 20 14C20 14.2625 19.983 14.5265 19.95 14.784L20.941 14.913C20.98 14.613 21 14.3055 21 14ZM20.473 11.331C20.2402 10.7673 19.9348 10.2365 19.5645 9.752L18.7695 10.3595C19.0874 10.7747 19.3496 11.2298 19.5495 11.713L20.473 11.331ZM18.28 8.4605C17.7979 8.0873 17.2691 7.77869 16.707 7.5425L16.32 8.465C16.8015 8.6675 17.255 8.932 17.669 9.252L18.28 8.4605ZM17.001 16.294L14.5 13.793V9.5H13.5V14.207L16.294 17.001L17.001 16.294Z",
    fill: "#E4A400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashDelay);
export default __webpack_public_path__ + "static/media/Dash-Delay.7ed0c7890c3bde2239bcb22a06e06a31.svg";
export { ForwardRef as ReactComponent };